import $ from 'jquery';

export const createCartProduct = ({ cart, isBusy, isStale, setBusy, announce, mutate }) => {
    const panel = cart.querySelector('.SidebarCart__product');
    const body = cart.querySelector('.SidebarCart__body');
    let request = null;
    let variants = [];
    let selectedVariant = null;
    let origin = null;
    let scrollTop = 0;
    let basePrice = '';
    let baseImage = '';
    const isOpen = () => !panel.hidden;

    const update = () => {
        const form = panel.querySelector('.CartProduct__form');
        const quantity = form && form.querySelector('[name="quantity"]');
        if (!quantity) return;
        const selected = {};
        const groups = Array.from(form.querySelectorAll('fieldset'));
        const matches = (variant, attributes) =>
            Object.entries(attributes).every(
                ([name, value]) => !variant.attributes[name] || variant.attributes[name] === value,
            );
        // Earlier choices constrain later ones, so changing colour can never trap the size choice.
        groups.forEach((group) => {
            group.querySelectorAll('input[type="radio"]').forEach((input) => {
                input.disabled = !variants.some(
                    (variant) =>
                        variant.available &&
                        matches(variant, { ...selected, [input.name]: input.value }),
                );
                if (input.disabled) input.checked = false;
                input.closest('label').title = input.disabled ? 'Ta opcja jest niedostępna' : '';
            });
            const checked = group.querySelector('input:checked');
            if (checked) selected[checked.name] = checked.value;
        });
        const complete = Object.keys(selected).length === groups.length;
        selectedVariant = complete
            ? variants.find((variant) => variant.available && matches(variant, selected))
            : null;
        quantity.min = selectedVariant ? selectedVariant.min : 1;
        if (selectedVariant && selectedVariant.max >= 0) quantity.max = selectedVariant.max;
        else quantity.removeAttribute('max');
        const amount = Number(quantity.value);
        const validQuantity =
            /^[1-9][0-9]*$/.test(quantity.value) &&
            Number.isInteger(amount) &&
            amount >= Number(quantity.min) &&
            (quantity.max === '' || amount <= Number(quantity.max));
        quantity.readOnly =
            !!selectedVariant && selectedVariant.max === selectedVariant.min && validQuantity;
        const ready = !!selectedVariant && validQuantity;
        panel.querySelector('[data-product-price]').innerHTML = selectedVariant
            ? selectedVariant.price
            : basePrice;
        const image = selectedVariant ? selectedVariant.image : baseImage;
        const imageSlot = panel.querySelector('[data-product-image]');
        if (imageSlot.dataset.variant !== String(selectedVariant ? selectedVariant.id : 'base')) {
            imageSlot.innerHTML = image;
            imageSlot.dataset.variant = String(selectedVariant ? selectedVariant.id : 'base');
            delete imageSlot.dataset.fallback;
        }
        const status = panel.querySelector('[data-product-status]');
        let message = 'Wybierz opcje produktu.';
        if (!variants.some((variant) => variant.available))
            message = 'Ten produkt jest obecnie niedostępny.';
        else if (complete && !selectedVariant) message = 'Ta kombinacja opcji jest niedostępna.';
        else if (selectedVariant && !validQuantity)
            message =
                selectedVariant.max >= 0
                    ? `Wybierz od ${selectedVariant.min} do ${selectedVariant.max} szt.`
                    : `Wybierz co najmniej ${selectedVariant.min} szt.`;
        else if (ready) message = selectedVariant.stock_note || 'Wybrany wariant jest dostępny.';
        status.textContent = message;
        status.classList.toggle('is-available', ready);
        form.querySelector('[type="submit"]').disabled = !ready || isBusy() || isStale();
        panel.querySelector('[data-product-step="-1"]').disabled =
            Number(quantity.value) <= Number(quantity.min);
        panel.querySelector('[data-product-step="1"]').disabled =
            quantity.max !== '' && Number(quantity.value) >= Number(quantity.max);
    };

    const close = (configuredKey = '', restoreFocus = true) => {
        if (!isOpen()) return;
        const pending = request;
        request = null;
        if (pending) pending.abort();
        panel.hidden = true;
        panel.innerHTML = '';
        body.hidden = false;
        variants = [];
        selectedVariant = null;
        const scroll = body.querySelector('.SidebarCart__scroll');
        if (scroll) scroll.scrollTop = scrollTop;
        if (restoreFocus && cart.classList.contains('active')) {
            const focusKey = configuredKey ? `product-${configuredKey}` : origin && origin.focus;
            const target = Array.from(body.querySelectorAll('[data-cart-focus]')).find(
                (element) => element.dataset.cartFocus === focusKey,
            );
            (target || cart.querySelector('.SidebarCart__close')).focus({ preventScroll: true });
            if (target && configuredKey) target.scrollIntoView({ block: 'nearest' });
        }
        setBusy();
    };

    const open = (target) => {
        if (isBusy() || isStale()) return;
        if (!isOpen()) {
            const scroll = body.querySelector('.SidebarCart__scroll');
            scrollTop = scroll ? scroll.scrollTop : 0;
        }
        origin = {
            id: target.dataset.cartProduct,
            key: target.dataset.cartKey || '',
            view: target.dataset.cartView,
            focus: target.dataset.cartFocus,
        };
        announce();
        panel.innerHTML =
            '<div class="CartProduct"><div class="CartProduct__nav"><button type="button" class="Button--no-style" data-cart-product-back>← Wróć do koszyka</button></div><div class="CartProduct__scroll" role="status">Wczytujemy produkt…</div></div>';
        body.hidden = true;
        panel.hidden = false;
        panel.querySelector('[data-cart-product-back]').focus({ preventScroll: true });
        const current = $.ajax({
            url: jsData.ajaxUrl,
            type: 'GET',
            dataType: 'json',
            cache: false,
            timeout: 20000,
            data: {
                action: 'ravessa_sidebar_product',
                product_id: origin.id,
                cart_item_key: origin.key,
            },
        });
        request = current;
        setBusy();
        const fail = (message) => {
            announce(message || 'Nie udało się wczytać produktu. Spróbuj ponownie.', 'error');
            panel.querySelector('.CartProduct__scroll').innerHTML =
                '<button type="button" class="Button--no-style CartProduct__submit" data-product-retry>Spróbuj ponownie</button>';
        };
        current
            .done((response) => {
                if (request !== current) return;
                if (!response.success || !response.data || typeof response.data.html !== 'string') {
                    fail(response.data && response.data.message);
                    return;
                }
                variants = response.data.variants || [];
                panel.innerHTML = response.data.html;
                if (response.data.nonce) cart.dataset.nonce = response.data.nonce;
                basePrice = panel.querySelector('[data-product-price]').innerHTML;
                baseImage = panel.querySelector('[data-product-image]').innerHTML;
                const sizes = panel.querySelector('.CartProduct__sizes');
                if (origin.view === 'sizes' && sizes) {
                    sizes.open = true;
                    sizes.querySelector('summary').focus({ preventScroll: true });
                } else panel.querySelector('.CartProduct__title').focus({ preventScroll: true });
            })
            .fail((xhr, status) => {
                if (status !== 'abort' && request === current)
                    fail(
                        xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.message,
                    );
            })
            .always(() => {
                if (request !== current) return;
                request = null;
                setBusy();
            });
    };

    panel.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-product-back]')) {
            if (!isBusy() || request) close();
            return;
        }
        if (isBusy() || isStale()) {
            event.preventDefault();
            return;
        }
        if (event.target.closest('[data-product-retry]')) {
            open({
                dataset: {
                    cartProduct: origin.id,
                    cartKey: origin.key,
                    cartView: origin.view,
                    cartFocus: origin.focus,
                },
            });
            return;
        }
        const step = event.target.closest('[data-product-step]');
        if (step) {
            const quantity = panel.querySelector('[name="quantity"]');
            if (Number(step.dataset.productStep) > 0) quantity.stepUp();
            else quantity.stepDown();
            update();
        }
    });
    panel.addEventListener('change', update);
    panel.addEventListener('input', (event) => {
        if (event.target.name === 'quantity') update();
    });
    panel.addEventListener(
        'error',
        (event) => {
            if (!event.target.matches('img')) return;
            const slot = event.target.closest('[data-product-image]');
            if (!slot) return;
            if (!slot.dataset.fallback && slot.dataset.variant !== 'base') {
                slot.dataset.fallback = 'true';
                slot.innerHTML = baseImage;
            } else {
                slot.innerHTML =
                    '<span class="CartProduct__noImage" role="img" aria-label="Zdjęcie produktu niedostępne"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M5 7h14l1 14H4L5 7Zm3 1V6a4 4 0 0 1 8 0v2"/></svg></span>';
            }
        },
        true,
    );
    panel.addEventListener('submit', (event) => {
        if (!event.target.matches('.CartProduct__form')) return;
        event.preventDefault();
        if (isBusy() || isStale()) return;
        update();
        if (
            !selectedVariant ||
            event.target.querySelector('[type="submit"]').disabled ||
            !event.target.reportValidity()
        )
            return;
        const attributes = {};
        event.target.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
            attributes[input.name] = input.value;
        });
        mutate('configure', {
            product_id: event.target.dataset.productId,
            cart_item_key: event.target.dataset.cartKey,
            variation_id: selectedVariant.id,
            quantity: event.target.querySelector('[name="quantity"]').value,
            attributes,
        });
    });

    return {
        open,
        close,
        isOpen,
        isLoading: () => !!request,
        setBusy: (busy) => {
            const form = panel.querySelector('.CartProduct__form');
            if (form) {
                form.inert = busy;
                form.setAttribute('aria-busy', String(busy));
                update();
            }
        },
    };
};
